import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Alert, Button, Container, Row, Col } from 'react-bootstrap';
import { FaGoogle } from 'react-icons/fa';
import ReCaptcha from './reCAPTCHA';
import './App.css';
import { getAuth, signInWithEmailAndPassword,GoogleAuthProvider, signInWithPopup  } from "firebase/auth";
import { auth } from '../firebase'; 

import axios from 'axios';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [captchaValue, setCaptchaValue] = useState(null);
    const navigate = useNavigate();

    // Connexion classique via l'API backend
    const handleLogin = async (e) => {
        e.preventDefault();
    
        if (!captchaValue) {
            setError('Veuillez compléter le CAPTCHA.');
            return;
        }
    
        try {
            const auth = getAuth();
            const userCredential = await signInWithEmailAndPassword(auth, email, password);
    
            // Récupérer l'idToken de l'utilisateur
            const idToken = await userCredential.user.getIdToken();
            console.log("Token généré :", idToken);
    
            // Envoyer le idToken au backend pour l'authentification
            const response = await axios.post("http://localhost:5000/api/auth/login", { idToken });
    
            // Vérification de la réponse du serveur
            if (response.status === 200) {
                const { isAdmin } = response.data;
    
                // Sauvegarder le token dans le localStorage pour une utilisation future
                localStorage.setItem('idToken', idToken);
    
                // Rediriger selon le rôle
                if (isAdmin) {
                    navigate("/admin"); // Redirige vers l'interface admin
                } else {
                    navigate('/accueil'); // Page client
                }
            } else {
                setError('Erreur serveur. Veuillez réessayer plus tard.');
            }
        } catch (error) {
            console.error("Erreur dans le frontend :", error.message);
            setError(error.message || 'Une erreur est survenue. Veuillez réessayer.');
        }
    };
    

    const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: 'select_account',
    });

    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      console.log('Utilisateur connecté avec Google:', user);

      navigate('/accueil');
    } catch (error) {
      console.error('Erreur lors de la connexion avec Google:', error.message);
    }

    };

    return (
        <Container fluid className="d-flex align-items-center justify-content-center min-vh-100 bg-light">
            <Row className="justify-content-md-center">
                <Col style={{ maxWidth: '500px' }} className="box shadow-lg rounded">
                    <div>
                        <img
                            src={`${process.env.PUBLIC_URL}/logoWhite.png`}
                            alt="Logo"
                            style={{ width: '150px', height: 'auto', marginRight: '10px' }}
                        />
                        <h1 style={{
                            marginLeft: '180px',
                            marginTop: '-55px',
                            color: '#9caf7d',
                            fontFamily: 'inherit',
                        }}>Log In</h1>
                    </div>
                    <br />
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form onSubmit={handleLogin}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Control
                                type="email"
                                placeholder="Entrer votre email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Control
                                type="password"
                                placeholder="Entrer votre mot de passe"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <br />
                        <ReCaptcha onChange={setCaptchaValue} />
                        <div>
                            <Button
                                style={{
                                    backgroundColor: '#9caf7d',
                                    fontFamily: 'inherit',
                                    border: 'none',
                                    width: '100%',
                                    marginLeft: '10px',
                                }}
                                variant="primary"
                                type="submit"
                            >
                                Log In
                            </Button>
                        </div>
                    </Form>
                    <hr />
                    <Button 
                        onClick={handleGoogleLogin} 
                        style={{
                            backgroundColor: '#db4437',
                            border: 'none',
                            padding: '10px',
                            borderRadius: '50%',
                            width: '50px',
                            height: '50px',
                            color: 'white',
                            marginLeft: '120px',
                        }}
                        className="d-flex justify-content-center align-items-center"
                    >
                        <FaGoogle style={{ color: '#fff', fontSize: '24px' }} />
                    </Button>
                    <div className="mt-3">
                        Vous n'avez pas un compte ? <Link to="/signup">Sign up</Link>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
